import { useSelector } from 'react-redux';
import get from 'lodash/get';

const useAuthToken = () => useSelector(state => get(state, 'Auth.user.accessToken'));

export default useAuthToken;
